import ResourceSvc from '@/services/resource.svc.js';
import { Input, Button, Select, Option } from 'element-ui'
import store from '@/services/store';
const svc = new ResourceSvc();

export default {
    name: 'BillingDetailsTab',
    components: {
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        Button
    },
    computed: {
        type() {
            return window.location.pathname.split('/')[1];
        },
        isMembershipBill() {
            return this.type === 'membership';
        },
        recurringEligiblePaymentItems() {
            const paymentItems = this.data.items || [];

            return paymentItems.filter(({ isRecurringEligible }) => isRecurringEligible)
        },
        clubRecurringItems() {
            const paymentItems = this.data.items || [];

            return paymentItems.filter(({ isClubRecurringEligible }) => isClubRecurringEligible)
        },
        isClubRenewalDisabled() {
            if (this.recurringEligiblePaymentItems.length > 0) {
                return !this.recurringEligiblePaymentItems.every(item => item.isRecurring);
            }
            return false;
        },
        isAutoRenewalValid() {
            if (this.isMembershipBill && this.recurringEligiblePaymentItems.length > 0) {
                return this.recurringEligiblePaymentItems.every(item => item.isRecurring);
            }
            return true;
        },
        isValidModel() {
            return this.data.billingAddress.address1 &&
                this.data.billingAddress.city &&
                this.data.billingAddress.country &&
                this.data.billingAddress.firstname &&
                this.data.billingAddress.surname &&
                this.data.billingAddress.phone &&
                this.data.billingAddress.postCode;
        },
        exitUrl() {
            //prefix "my" means "created by me"
            switch (this.type) {
                case 'race-entry':
                    return '/dashboard/races';
                case 'course':
                    return '/courses';
                case 'membership':
                    return '/dashboard/upgrade-membership';
                case 'club':
                    return '/dashboard/club/management';
                case 'race-sanctioning':
                    return '/dashboard/my-races';
            }

            return "/";
        },
        getController() {
            //prefix "User" means "my"
            switch (this.type) {
                case 'race-entry':
                    return 'UserRace';
                case 'course':
                    return 'UserCourse';
                case 'membership':
                    return 'UserMembership';
                case 'club':
                    return 'UserClub';
                case 'race-sanctioning':
                    return 'Race';
            }
            return null;
        },
        loginUrl() {
            return process.env.url.oldAppLogin;
        },
        thankYouUrl() {
            //prefix "my" means "created by me"
            switch (this.type) {
                case 'race-entry':
                    return '/dashboard/races';
                case 'course':
                    return '/course/thankyou/' + this.itemId;
                case 'membership':
                    return '/dashboard/upgrade-membership';
                case 'club':
                    return '/dashboard/club/management';
                case 'race-sanctioning':
                    return '/dashboard/my-races';
            }
            return "/";
        }
    },
    watch: {
        isClubRenewalDisabled(disabled) {
            if (disabled) {
                this.clubRecurringItems.forEach(item => { item.isClubRecurring = false; });
            }
        }
    },
    data() {
        return {
            data: {
                billingAddress: {
                    address1: '',
                    address2: '',
                    city: '',
                    country: '',
                    firstname: '',
                    surname: '',
                    phone: '',
                    postCode: '',
                    state: '',
                    isStatusActive: false,
                    countries: [],
                    id: 0,
                    userId: 0
                },
                price: 0,
                itemId: 0,
                registerUserId: 0,
                isRecurring: false,
                items: [],
            },
            isProcessing: true,
            us:'US'
        }
    },
    methods: {
        getUrlParamByName(name, defaultValue) {
            if ((new URL(window.location.href)).searchParams.get(name)) {
                return (new URL(window.location.href)).searchParams.get(name);
            }
            else {
                return defaultValue;
            }
        },
        loadData() {
            var self = this;
            window.scrollTo(0, 0);
            self.isProcessing = true;
            if (!self.getController) {
                self.showError("Request is not correct", "/");
                return;
            }
            svc.getBillingDataForUser(self.getController).then(response => {
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        if (allData.currentUserId == 0) {
                            self.$showError(allData.message);
                            self.login();
                            return;
                        }
                        self.showError(allData.message, allData.redirectUrl);
                        return;
                    }

                    self.data = allData;
                    self.data.billingAddress.postCode = '000';
                } else {
                    self.back();
                }
                self.isProcessing = false;
            },
            () => {
                self.showError("Error occured!", self.exitUrl);
            });
        },
        saveData() {
            if (!this.isValidModel) {
                this.$showError("Please fill required fields!");
                return;
            }
            if (this.data.billingAddress.country == this.us && this.data.billingAddress.state == null) {
                this.$showError("Please fill State field!");
                return;
            }
            window.scrollTo(0, 0);
            var self = this;
            var data = self.data;
            data.itemId = self.itemId;

            self.isProcessing = true;
            svc.createPaymentUrl(self.getController, data).then(response => {
                self.isProcessing = false;
                var allData = response.body;
                if (allData) {
                    if (!allData.isSuccess) {
                        if (allData.currentUserId == 0) {
                            self.$showError(allData.message);
                            self.login();
                            return;
                        }

                        self.showError(allData.message, allData.redirectUrl);
                        return;
                    }
                    else if (!allData.redirectUrl) {
                        window.location.href = self.thankYouUrl;
                    }
                    self.isProcessing = true;
                    self.showSuccessAndRedirectToSagePay(allData.redirectUrl);
                } else {
                    self.showError("Something went wrong!", self.exitUrl);
                }
            },
            () => {
                self.showError("Something went wrong!", self.exitUrl);
            });
        },
        exit() {
            window.location.href = this.exitUrl;
        },
        back() {
            this.$router.push(-1);
        },
        login() {
            window.location.href = this.loginUrl;
        },
        showSuccessAndRedirectToSagePay(redirectUrl) {
            var self = this;
            self.$notify({ message: 'Success! Redirecting to SagePay in a second!', type: 'success' });
            setTimeout(function () { //just need to do all not so fast
                window.location.href = redirectUrl;
            }, 1500);
        },
        showError(message, redirectUrl) {
            var self = this;
            if (!message) {
                message = 'Something went wrong. Incorrect request!';
            }
            self.$notify({
                message: message,
                type: 'danger',
                timeout: 7000
            });


            if (redirectUrl) {
                setTimeout(function () {
                    if (redirectUrl.indexOf("http") === 0) {
                        window.location.href = redirectUrl;
                    }
                    else {
                        self.$router.push({ path: redirectUrl});
                    }
                }, 3000);
            }
        }
    },
    created() {
        this.loadData();
    },
    mounted() {
        var self = this;
        var user = store.getters.getCurrentUser;
        if (user && user.roles && user.roles.length) {
            if (user.roles.some(function (el) { return el === "Admin"; })) {
                self.$router.push({ path: "/" });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/billing-page/billing-page.js